import {
  Callout,
  DetailsList,
  DetailsListLayoutMode,
  FontWeights,
  IColumn,
  Link,
  mergeStyleSets,
  SelectionMode,
  Text,
} from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import React from 'react';
import { genkey } from '../../common/constants';
import { TablaGeneralPosiciones, TablaPosicionesFairplay } from '../../system/SystemClient';
import ClubImageCircle from '../Common/ClubImageCircle';

const TorneoTabTablaGeneralPosicionesFairplay = ({
  tablaFairplay,
  highlightClubId,
  tablaGeneralPosiciones,
}: {
  tablaFairplay: TablaPosicionesFairplay[];
  highlightClubId?: string;
  tablaGeneralPosiciones: TablaGeneralPosiciones[];
}) => {
  const [isCalloutVisible, setIsCalloutVisible] = React.useState<boolean>(false);
  const toggleIsCalloutVisible = () => setIsCalloutVisible(!isCalloutVisible);
  console.log('tablaGeneralPosiciones', tablaGeneralPosiciones);
  const buttonId = useId(genkey());
  const labelId = useId(genkey());
  const descriptionId = useId(genkey());

  const styles = mergeStyleSets({
    callout: {
      width: 300,
      maxWidth: '90%',
      padding: '10px 14px',
    },
    title: {
      marginBottom: 12,
      fontWeight: FontWeights.semilight,
    },
    link: {
      display: 'block',
      marginTop: 20,
    },
  });

  const getCols = (compact?: boolean) => {
    const columnsDesktop: IColumn[] = [
      {
        key: 'posicion',
        name: '#',
        fieldName: 'posicion',
        minWidth: compact ? 10 : 50,
        maxWidth: compact ? 10 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.puesto}</span>;
        },
      },
      {
        key: 'club',
        name: 'Club',
        fieldName: 'club',
        minWidth: compact ? 180 : 400,
        maxWidth: compact ? 180 : 400,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return (
            <div>
              {compact ? (
                <>
                  <div style={{ display: 'inline-block' }}>
                    <ClubImageCircle escudo={item.club_escudo} width={19} height={19}></ClubImageCircle>
                  </div>

                  <span
                    style={{
                      fontSize: 12,
                      marginTop: 0,
                      display: 'inline-block',
                      position: 'relative',
                      bottom: 6,
                      left: 3,
                      fontWeight: !!highlightClubId && highlightClubId === item.clubId ? 500 : 400,
                      color: !!highlightClubId && highlightClubId === item.clubId ? 'red' : '#605e5c',
                    }}
                  >
                    {item.club}
                  </span>
                </>
              ) : (
                <>
                  <div style={{ display: 'inline-block' }}>
                    <ClubImageCircle escudo={item.club_escudo} width={30} height={30}></ClubImageCircle>
                  </div>

                  <span
                    style={{
                      fontSize: 16,
                      marginTop: 0,
                      display: 'inline-block',
                      position: 'relative',
                      bottom: 10,
                      left: 10,
                      fontWeight: !!highlightClubId && highlightClubId === item.clubId ? 500 : 400,
                      color: !!highlightClubId && highlightClubId === item.clubId ? 'red' : '#605e5c',
                    }}
                  >
                    {item.club}
                  </span>
                </>
              )}
            </div>
          );
        },
      },
      {
        key: 'PTS',
        name: 'PTS',
        fieldName: 'PTS',
        minWidth: compact ? 25 : 50,
        maxWidth: compact ? 25 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16, fontWeight: 700 }}>{item.puntos}</span>;
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>PTS</span>
          </div>
        ),
      },
      {
        key: 'V (J)',
        name: 'V (J)',
        fieldName: 'V (J)',
        minWidth: compact ? 30 : 50,
        maxWidth: compact ? 30 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return (
            <span className="text-center" style={{ fontSize: compact ? 12 : 16 }}>
              {item.tarjetasVerdesJugadores}
            </span>
          );
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>V (J)</span>
          </div>
        ),
      },

      {
        key: 'A (J)',
        name: 'A (J)',
        fieldName: 'A (J)',
        minWidth: compact ? 30 : 50,
        maxWidth: compact ? 30 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return (
            <span className="text-center" style={{ fontSize: compact ? 12 : 16 }}>
              {item.tarjetasAmarillasJugadores}
            </span>
          );
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>A (J)</span>
          </div>
        ),
      },

      {
        key: 'R (J)',
        name: 'R (J)',
        fieldName: 'R (J)',
        minWidth: compact ? 30 : 50,
        maxWidth: compact ? 30 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.tarjetasRojasJugadores}</span>;
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>R (J)</span>
          </div>
        ),
      },

      {
        key: 'A (CT)',
        name: 'A (CT)',
        fieldName: 'A (CT)',
        minWidth: compact ? 40 : 50,
        maxWidth: compact ? 40 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.tarjetasAmarillasEntrenadores}</span>;
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>A (CT)</span>
          </div>
        ),
      },

      {
        key: 'R (CT)',
        name: 'R (CT)',
        fieldName: 'R (CT)',
        minWidth: compact ? 40 : 50,
        maxWidth: compact ? 40 : 50,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.tarjetasRojasEntrenadores}</span>;
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>R (CT)</span>
          </div>
        ),
      },

      {
        key: 'Susp. CJ',
        name: 'Susp. CJ',
        fieldName: 'Susp. CJ',
        minWidth: compact ? 70 : 70,
        maxWidth: compact ? 70 : 70,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.suspensionCancha}</span>;
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>Susp. CJ</span>
          </div>
        ),
      },
      {
        key: 'Susp. JM',
        name: 'Susp. JM',
        fieldName: 'Susp. JM',
        minWidth: compact ? 70 : 70,
        maxWidth: compact ? 70 : 70,
        isResizable: true,
        onRender: (item: TablaPosicionesFairplay) => {
          return <span style={{ fontSize: compact ? 12 : 16 }}>{item.suspensionJuezMesa}</span>;
        },
        onRenderHeader: (props) => (
          <div onClick={() => toggleIsCalloutVisible()}>
            <span>Susp. JM</span>
          </div>
        ),
      },
    ];

    /**
    if (compact) {
      const aux = columnsDesktop[6];
      columnsDesktop[6] = columnsDesktop[9];
      columnsDesktop[9] = aux;
    }
     */
    return columnsDesktop;
  };

  return (
    <>
      <>
        {/* =====================================================================
                              VISTA DESKTOP
        =====================================================================*/}
        <div className="" style={{ textAlign: 'right' }}>
          <Link id={buttonId} title="Ver referencias" onClick={toggleIsCalloutVisible}>
            Referencias
          </Link>

          {isCalloutVisible && (
            <Callout
              className={styles.callout}
              ariaLabelledBy={labelId}
              ariaDescribedBy={descriptionId}
              role="dialog"
              gapSpace={0}
              target={`#${buttonId}`}
              onDismiss={toggleIsCalloutVisible}
              setInitialFocus
            >
              <Text variant="medium" block className="fw-500" id={labelId}>
                V (J): <span style={{ fontWeight: 400 }}>Tarjetas verdes en jugadores</span>
              </Text>
              <Text variant="medium" block className="fw-500" id={labelId}>
                A (J): <span style={{ fontWeight: 400 }}>Tarjetas amarillas en jugadores</span>
              </Text>
              <Text variant="medium" block className="fw-500" id={labelId}>
                R (J): <span style={{ fontWeight: 400 }}>Tarjetas rojas en jugadores</span>
              </Text>
              <Text variant="medium" block className="fw-500" id={labelId}>
                A (CT): <span style={{ fontWeight: 400 }}>Tarjetas amarillas en cuerpo técnico</span>
              </Text>
              <Text variant="medium" block className="fw-500" id={labelId}>
                R (CT): <span style={{ fontWeight: 400 }}>Tarjetas rojas en cuerpo técnico</span>
              </Text>
              <Text variant="medium" block className="fw-500" id={labelId}>
                Susp. CJ: <span style={{ fontWeight: 400 }}>Suspension de campos de juego</span>
              </Text>
              <Text variant="medium" block className="fw-500" id={labelId}>
                Susp. JM: <span style={{ fontWeight: 400 }}>Suspension de jueces de mesa</span>
              </Text>
            </Callout>
          )}
        </div>{' '}
        <div id="viewDesktop" className="ms-hiddenSm">
          <div className="ms-Grid-row ">
            <div className="ms-Grid-col ms-sm12 text-center">
              <DetailsList
                className="no-scroll"
                onShouldVirtualize={() => false}
                items={tablaFairplay}
                columns={getCols()}
                setKey="set"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
              />
            </div>
          </div>

          {tablaGeneralPosiciones.map((item) => (
            <div className="ms-Grid-row mt-5">
              <div
                className="ms-Grid-col ms-sm12 text-center"
                style={{
                  padding: 12,
                  background: 'gray',
                }}
              >
                <Text variant="mediumPlus" style={{ fontWeight: 500 }}>
                  General Fairplay - {item.rotulo}
                </Text>
              </div>

              <div className="ms-Grid-col ms-sm12 text-center">
                <DetailsList
                  className="no-scroll"
                  onShouldVirtualize={() => false}
                  items={item.tabla.map((item) => {
                    return {
                      ...item,
                      tarjetasVerdesJugadores: item.jugadoresVerdes,
                      tarjetasAmarillasJugadores: item.jugadoresAmarillas,
                      tarjetasRojasJugadores: item.jugadoresRojas,
                      tarjetasAmarillasEntrenadores: item.entrenadoresAmarillas,
                      tarjetasRojasEntrenadores: item.entrenadoresRojas,
                    };
                  })}
                  columns={getCols()}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                />
              </div>
            </div>
          ))}
        </div>
        {/* =====================================================================
                              VISTA MOBILE
        =====================================================================*/}
        <div id="viewMobile" className="ms-hiddenMdUp">
          <div className="ms-Grid-row ">
            <div className="ms-Grid-col ms-sm12 text-center">
              <DetailsList
                className=""
                onShouldVirtualize={() => false}
                items={tablaFairplay}
                columns={getCols(true)}
                setKey="set"
                layoutMode={DetailsListLayoutMode.justified}
                selectionMode={SelectionMode.none}
              />
            </div>
          </div>

          {tablaGeneralPosiciones.map((item) => (
            <div className="ms-Grid-row mt-5">
              <div
                className="ms-Grid-col ms-sm12 text-center"
                style={{
                  padding: 12,
                  background: 'gray',
                }}
              >
                <Text variant="mediumPlus" style={{ fontWeight: 500 }}>
                  General Fairplay - {item.rotulo}
                </Text>
              </div>

              <div className="ms-Grid-col ms-sm12 text-center">
                <DetailsList
                  className="no-scroll"
                  onShouldVirtualize={() => false}
                  items={item.tabla.map((item) => {
                    return {
                      ...item,
                      tarjetasVerdesJugadores: item.jugadoresVerdes,
                      tarjetasAmarillasJugadores: item.jugadoresAmarillas,
                      tarjetasRojasJugadores: item.jugadoresRojas,
                      tarjetasAmarillasEntrenadores: item.entrenadoresAmarillas,
                      tarjetasRojasEntrenadores: item.entrenadoresRojas,
                    };
                  })}
                  columns={getCols(true)}
                  setKey="set"
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={SelectionMode.none}
                />
              </div>
            </div>
          ))}
        </div>
      </>
    </>
  );
};

interface IPropsCallout {
  isCalloutVisible: boolean;
  toggleIsCalloutVisible: () => void;
}

export const CalloutReferenciasTablasFairplay = (props: IPropsCallout) => {};

export default TorneoTabTablaGeneralPosicionesFairplay;
